import {session} from './index'
import { apiGet } from '@/services'
import Cookie from 'js-cookie'
import qs from 'qs'

// 防重复请求设置reqNo
const currentReq = {
	reqNo: '',
	url: '',
	reqStatus: false, // true:请求中；false:请求完成
	setReqStatus: function(val) {
		this.reqStatus = val
	},
	setReqNo: function(url) {
		// 判断当前请求接口与上一次是否是同一接口且上一次请求还未返回信息
		if (!(this.url === url && this.reqStatus)) {
			this.url = url
			this.reqNo = Date.now()
		}
		this.setReqStatus(true) // 请求中
		return this.reqNo
	}
}

const checkStatus = (res) => {
	currentReq.setReqStatus(false) // 请求完成
  console.log('net', res)
	if (res.data.code === '1002') {
		apiGet('partner/open/wechat/authUrl').then(res => {
      console.log('auth---', res)
			if (res.code === '0000') {
        console.log('data', res.data)
				window.location.href = res.data
			}
		})
		throw new Error('1002')
  }
  if (res.data.code === 303 || res.data.code === 301) {
    window.location = res.data.url
    return res.data
  }
	if (res.status >= 200 && res.status <= 300) {
		return res.data
	}
}

export function request(url, options) {
  if (!Cookie.get('helper_tk')) {
    let token = ''
    token = qs.parse(location.search.slice(1)).token || ''
    if (token) {
      Cookie.set('helper_tk', token, { expires: 7 })
    }
  }
	global.BUS.$axios.defaults.headers.reqNo = currentReq.setReqNo(url)
  global.BUS.$axios.defaults.headers['X-CSRF-TOKEN'] = session('X-CSRF-TOKEN')
  global.BUS.$axios.defaults.headers['X-Pd-Language'] = 'zh-cn'
	global.BUS.$axios.defaults.headers.Authorization = Cookie.get('helper_tk')
	global.BUS.$axios.defaults.headers.offset = new Date().getTimezoneOffset() / 60
	return global.BUS.$axios(url, options)
										.then(checkStatus)
										.then((data) => data)
										.catch(err => {
                      console.log(url, 'err-info', err)
                      // return {
                      //   code: '1002',
                      //   err: err,
                      //   msg: err.toString()
                      // }
                      // if (err.msg === '101') {
                      //   return {
                      //     code: '1002',
                      //     err: err,
                      //     msg: err.toString()
                      //   }
                      // } else {
                      //   return {
                      //     code: 500,
                      //     err: err,
                      //     msg: err.toString()
                      //   }
                      // }
                    })
}
